jQuery(function ($) {
	prepareMenuForHoverTouch($);
	preparePopupElements($);
	
	lazyload();
	
	
	prepareLBPagesClick($);
	
});

/** Menu Hover Triggers **/

function prepareMenuForHoverTouch($) {
	$('.menu-active-target').hover(function () {
		$(this).addClass('mouse-over');
	}, function () {
		$(this).removeClass('mouse-over');
	});
	$('#main-nav li').hover(function () {
		menuActivate($, $(this));
	}, function () {
		menuDeactivate($, $(this));
	});
	$('.menu-active-target').hover(function () {
		$('body').addClass('main-menu-active');
	}, function () {
		if ($('.menu-active-target.mouse-over').length == 0) {
			$('body').removeClass('main-menu-active');
		}

	});
}
function menuActivate($, _this) {
	_this.addClass('active-menu');
	$('body').addClass('main-menu-active');
}

function menuDeactivate($, _this) { //return false;
	_this.removeClass('active-menu');
	if ($('.menu-active-target.mouse-over').length == 0) {
		$('body').removeClass('main-menu-active');
	}
}
/** Popup Triggers **/
function preparePopupElements($) {
  
  	var screenScale;
    $(window).resize(function() {
      clearTimeout(screenScale);
      screenScale = setTimeout(function(){
      testPopupScroll($);
      }, 500);

    });
	$('.popup-open').click(function () {
		var _elem = $($(this).attr('data-target'));
		closePopupElements($,function(){
			openPopupElements($,_elem);
		});
	});
}
function closePopupElements($,_f) {
	$('#main-wrap-right').removeClass('elevate');
	if ($('#popup-display').length) {
		
        $('#popup-block').append($('#popup-display .popup-element'));
		$('#popup-display .lb-page_image').each(function(){
			if($(this).width()/$(this).height() != $(this).attr('data-aspectratio')){
				$(this).css({
					'height': '',
					'width': ''
				});
			}

		});
        
        _f();
		
	}else{
		_f();
	}
}
function openPopupElements($,_elem){
    if($('#popup-display').length == 0){
      $('#main-wrap-right').append($('<div id="popup-display"></div>'));
    }
  	$('body').removeClass('page-home');
  	var _bg = _elem.attr('data-image');
	if(typeof _bg !== typeof undefined){
		$('#main-wrap-right').css('background-image','url(\''+_bg+'\')');
	}
    $('#popup-display').append(_elem);
	
	if(_elem.hasClass('lookbook-wrapper')){
		$('#main-wrap-right').addClass('elevate');
	}
    
    testPopupScroll($);
}
function testPopupScroll($){
	sameSizePages($);
	if($('#popup-display .popup-element').height() < $('#popup-display .popup-element .lb-inner').height()){
      	//$('#popup-display').addClass('scrollable');
		//console.log('scrollable');
		new SimpleBar($('#popup-display .lookbook-wrapper')[0], { 
			autoHide: false,
			forceVisible: true
		});
		
    }else{
		//console.log('non-scrollable');
      $('#popup-display');
    }
}

function sameSizePages($){
	
	var _pdphWidth = $('#pdph').width()-($('.lb-page-wrap').first().outerWidth()-$('.lb-page-wrap').first().width());
	var _pdphHeight = $('#pdph').height()-($('.lb-page-wrap').first().outerHeight()-$('.lb-page-wrap').first().height());
	$('.lb-page-wrap img').each(function(){
		var _oImg = $(this);
		var _asp = _oImg.attr('data-aspectratio');
		var _oImg_width =(_pdphWidth);
		var _oImg_height = (_pdphWidth/_asp);
		if(_oImg_height > _pdphHeight){
			_oImg_width = _pdphHeight * _asp;
			_oImg_height = _pdphHeight;
		}
		_oImg.width(_oImg_width);
		_oImg.height(_oImg_height);
	});
	$('.lookbook-wrapper').each(function(){
		var _curWrap = $(this);
		var _minH = 9999;
		
		if($('.lb-page-wrap img',_curWrap).length){
			$('.lb-page-wrap img',_curWrap).each(function(){
				var _img = $(this);
				var _asp = _img.attr('data-aspectratio');
				var _maxH = _img.attr('data-xheight');
				var actingHeight = _pdphWidth/_asp;
				if(actingHeight > _pdphHeight){
					actingHeight = _pdphHeight;
				}
				if(actingHeight > _maxH){
					actingHeight = _maxH;
				}
				if(_minH > actingHeight){
					_minH = actingHeight;
				}
				
			});
		}
		
		/*$('.lb-page-wrap img',_curWrap).each(function(){
			var _curImg = $(this);
			if(_curImg.height() > 10 && _curImg.height() < _minH){
				_minH = _curImg.height();
			}
		});
		if(_minH > ($(window).height() * 0.9)){
			_minH = ($(window).height() * 0.9);
		}*/
		$('.lb-page-wrap img',_curWrap).css({
			'max-height':_minH
		});
		$('.lb-page-wrap img',_curWrap).each(function(){
			var _nCImg = $(this);
			var _asp = _nCImg.attr('data-aspectratio');
			var _asCalc = _nCImg.width()/_nCImg.height();
			if(Number.parseFloat(_asCalc).toPrecision(3) != Number.parseFloat(_asp).toPrecision(3)){
				_nCImg.removeAttr('height').removeAttr('width').css({
					'width':''
				});
			}
			
		});
	});
}
function prepareLBPagesClick($){
	$('.lb-page-wrap').click(function(){
		var _pWrap = $(this);
		var _targetSlide = _pWrap.attr('data-bid');
		var _targetWrap = _pWrap.attr('data-lbid');
		
		var _targ = $('.slick-'+_targetWrap+'.late-slick-slider');
		var _index = $('.slide[data-bid='+_targetSlide+']').index();
		
		var _clone = _targ.clone(true);
		_clone.addClass('slick-active-slider');
		_clone.appendTo('body');
		$('.lazy.slick-active-slider').slick({
		  lazyLoad: 'ondemand',
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  
		});
		$('.lazy.slick-active-slider').slick('slickGoTo',_index);
		
		$('<a href="javascript:void(0);" class="popup-close corner-close" onclick="jQuery(\'.slick-active-slider\').remove();jQuery(this).remove();"><span class="close"><img src="//cdn.shopify.com/s/files/1/0274/6009/t/10/assets/close-icon.svg?v=96194196909271422981576039413" /></span></a>').appendTo('body');
	});
}